<template>
  <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 pl-0 pr-0">
    <skeleton-screen v-if="!dataLoaded"></skeleton-screen>
    <div v-if="dataLoaded" class="col-md-12 col-sm-12 col-lg-12 col-xl-12 baise yuanjiao gundt mb-3 mrt" style="font-size: calc(7px + 0.4vw);border-radius: 12px 12px 12px 12px;min-height: 87vh;">
      <div class="yinc">
        <div class="col-md-12 pl-0 pr-0 yuanjiao d-flex justify-content-between pt-3">
          <div class="fullscreen-modal" style="width: 50%;position: relative;">
            <div class="p-3 yuanjiao" style="width: 100%;box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
              <img style="width: 100%;height: 30vh;object-fit: contain;" :src="mediaList[currentIndex].img_url.url" alt="fullscreen" class="fullscreen-image yuanjiao" />
            </div>
            <img class="curpo" @click="move(-1)" style="width: calc(18px + 0.5vw);height: calc(30px + 0.5vw);position: absolute;bottom: 14%;left: 0;z-index: 99;" src="@/img/details/icon_jklb_xiangzuo@2x.png">
              <img class="curpo" @click="move(1)" style="width: calc(18px + 0.5vw);height: calc(30px + 0.5vw);position: absolute;right: 0;bottom: 14%;z-index: 99;" src="@/img/details/icon_jklb_xiangyou@2x.png">
            <div class="thumbnail-container pb-3 " style="width: 100%;overflow-x: auto;position: relative;">
              <div class="d-flex mt-3" style="gap: 10px;">
                <img v-for="(image, index) in mediaList" :key="index" :src="image.img_url.url" :class="{ selected: currentIndex === index }" @click="asdfsdgv(index)" alt="缩略图" :style="{border:currentIndex === index ? '2px solid #ffd672' : ''}" />
              </div>
            </div>
          </div>
          <div style="width: 48%;">
            <div style="font-size: calc(13px + 0.4vw);font-weight: 600;">{{ info.name ? info.name : '' }}</div>
            <div class="d-flex justify-content-between align-items-center mb-3 mt-3">
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("物資類別") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: calc(100% - 80px);">{{ info.goods_type.name ? info.goods_type.name : '--' }}</div>
              </div>
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("物資狀況") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: calc(100% - 80px);">{{ info.goods_status ? info.goods_status : '--' }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("剩餘數量") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: calc(100% - 80px);">{{ info.surplus_number ? info.surplus_number : '--' }}</div>
              </div>
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("配送方式") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: calc(100% - 80px);">{{ info.goods_delivery ? info.goods_delivery.name : '--' }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center" style="width: 100%;">
                <div class="mr-2" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("物資位置") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: calc(100% - 80px);">{{ info.goods_position ? info.goods_position : '--' }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center" style="width: 100%;">
                <div class="mr-2" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("捐贈團體") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: calc(100% - 80px);">{{ info.organization ? info.organization.name : '--' }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("生產日期") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: calc(100% - 80px);">{{ info.date_of_manufacture ? info.date_of_manufacture : '--' }}</div>
              </div>
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("有效期至") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: calc(100% - 80px);">{{ info.period_of_validity ? info.period_of_validity : '--' }}</div>
              </div>
            </div>
            <div class="d-flex">
              <div v-if="leix==2" class="mr-3 pl-5 pr-5 pt-3 pb-3 yuanjiao curpo ckqbb mt-5 sjbzt" @click="dascas()" style="font-size: calc(7px + 0.4vw);background: #FFD672;border: none;color: #000;">
                {{ $t("申請物資") }}
              </div>
              <div v-else class="mr-3 pl-5 pr-5 pt-3 pb-3 yuanjiao curpo ckqbb mt-5 sjbzt" @click="dascas()" style="font-size: calc(7px + 0.4vw);background: #f6f4f0;border: none;color: #000;">
                {{ $t("申請物資") }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="mb-2" v-if="info.description" style="font-size: calc(11px + 0.4vw);font-weight: 600;">{{ $t("物資說明") }}</div>
          <div class="mb-3" v-if="info.description">
            <div style="color: #1A1A1A;font-size: calc(9px + 0.4vw);">{{ info.description }}</div>
          </div>
          <div class="mb-3" style="font-size: calc(11px + 0.4vw);font-weight: 600;">{{ $t("團體認領記錄") }}</div>
          <div class="d-flex align-items-center">
            <div class="mr-3 d-flex align-items-center pl-3 pr-3 pt-2 pb-2 justify-content-between yuanjiao" style="background: #FFEAB8;width: 24%;">
              <div style="font-size: calc(9px + 0.4vw);">{{ $t("好人積分") }}</div>
              <div style="font-size: calc(9px + 0.4vw);font-weight: 600;">{{ info.sum_good_coin ? info.sum_good_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
            </div>
            <div class="mr-3 d-flex align-items-center pl-3 pr-3 pt-2 pb-2 justify-content-between yuanjiao" style="background: #FFEAB8;width: 24%;">
              <div style="font-size: calc(9px + 0.4vw);">{{ $t("碳積分") }}</div>
              <div style="font-size: calc(9px + 0.4vw);font-weight: 600;">{{ info.sum_carbon_coin ? info.sum_carbon_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
            </div>
          </div>
          <div class="d-flex align-items-center mt-3 justify-content-between" style="flex-wrap: wrap;">
            <div class="d-flex align-items-center pl-3 pr-3 pt-2 pb-2 justify-content-between yuanjiao mb-3" v-for="(item,index) in info.claim_record" :key="index" style="background: #F6F4F0;width: 49.5%;">
              <div style="font-size: calc(9px + 0.4vw);">{{ item.organization.name }}</div>
              <div class="d-flex" style="font-size: calc(9px + 0.4vw);">
                <div class="mr-1" style="color: #666666;">{{ $t("已認領") }}</div>
                <div class="mr-1" style="font-weight: 600;">{{ item.apply_number }}</div>
                <div style="color: #666666;">{{ $t("本") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="aaaa">
        <div class="col-md-12 pl-0 pr-0 yuanjiao pt-3">
          <div class="fullscreen-modal" style="width: 100%;position: relative;">
            <div class="p-3 yuanjiao" style="width: 100%;box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
              <img style="width: 100%;height: 23vh;object-fit: contain;" :src="mediaList[currentIndex].img_url.url" alt="fullscreen" class="fullscreen-image yuanjiao" />
            </div>
            <div style="position: absolute;bottom: 13%;left: 0;z-index: 99;">
              <img class="curpo" @click="move(-1)" style="width: calc(20px + 0.5vw);height: calc(30px + 0.5vw);" src="@/img/details/icon_jklb_xiangzuo@2x.png">
            </div>
            <img class="curpo" @click="move(1)" style="width: calc(20px + 0.5vw);height: calc(30px + 0.5vw);position: absolute;right: 0;bottom: 13%;z-index: 99;" src="@/img/details/icon_jklb_xiangyou@2x.png">
            <div class="thumbnail-container pb-3  lieb" style="width: 100%;overflow-x: auto;position: relative;">
              <div class="d-flex mt-3" style="gap: 10px;">
                <img v-for="(image, index) in mediaList" :key="index" :src="image.img_url.url" :class="{ selected: currentIndex === index }" @click="asdfsdgv(index)" alt="缩略图" :style="{border:currentIndex === index ? '2px solid #ffd672' : ''}" />
              </div>
            </div>
          </div>
          <div style="width: 100%;">
            <div class="sjbdzt mt-2" style="font-size: calc(13px + 0.4vw);font-weight: 600;">{{ info.name ? info.name :'' }}</div>
            <div class="d-flex justify-content-between align-items-center mb-3 mt-3">
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="sjbxzt mr-2" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("物資類別") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao sjbxzt" style="background: #F6F4F0;flex-grow: 1;">{{ info.goods_type.name ? info.goods_type.name : '--' }}</div>
              </div>
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2 sjbxzt" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("物資狀況") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao sjbxzt" style="background: #F6F4F0;flex-grow: 1;">{{ info.goods_status ? info.goods_status : '--' }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2 sjbxzt" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("剩餘數量") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao sjbxzt" style="background: #F6F4F0;flex-grow: 1;">{{ info.surplus_number ? info.surplus_number : '--' }}</div>
              </div>
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2 sjbxzt" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("配送方式") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao sjbxzt" style="background: #F6F4F0;flex-grow: 1;">{{ info.goods_delivery ? info.goods_delivery.name : '--' }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center" style="width: 100%;">
                <div class="mr-2 sjbxzt" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("物資位置") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao sjbxzt" style="background: #F6F4F0;flex-grow: 1;">{{ info.goods_position ? info.goods_position : '--' }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center" style="width: 100%;">
                <div class="mr-2 sjbxzt" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("捐贈團體") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao sjbxzt" style="background: #F6F4F0;width: calc(100% - 80px);">{{ info.organization ? info.organization.name : '--' }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2 sjbxzt" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("生產日期") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao sjbxzt" style="background: #F6F4F0;flex-grow: 1;">{{ info.date_of_manufacture ? info.date_of_manufacture : '--' }}</div>
              </div>
              <div class="d-flex align-items-center" style="width: 49%;">
                <div class="mr-2 sjbxzt" style="color: #666666;font-size: calc(8px + 0.4vw);">{{ $t("有效期至") }}</div>
                <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao sjbxzt" style="background: #F6F4F0;flex-grow: 1;">{{ info.period_of_validity ? info.period_of_validity : '--' }}</div>
              </div>
            </div>
            <div class="d-flex">
              <div v-if="leix==2" class="mr-3 pl-4 pr-4 pt-2 pb-2 yuanjiao curpo ckqbb mt-3 sjbzt" @click="dascas()" style="font-size: calc(7px + 0.4vw);background: #FFD672;border: none;color: #000;">
                {{ $t("申請物資") }}
              </div>
              <div v-else class="mr-3 pl-4 pr-4 pt-2 pb-2 yuanjiao curpo ckqbb mt-3 sjbzt" @click="dascas()" style="font-size: calc(7px + 0.4vw);background: #f6f4f0;border: none;color: #000;">
                {{ $t("申請物資") }}
              </div>
            </div>
          </div>
        </div>
        <div class="pb-1">
          <div class="mb-2 sjbzt mt-4" v-if="info.description" style="font-size: calc(11px + 0.4vw);font-weight: 600;">{{ $t("物資說明") }}</div>
          <div class="mb-3" v-if="info.description">
            <div class="sjbxzt" style="color: #1A1A1A;font-size: calc(9px + 0.4vw);">{{ info.description }}</div>
          </div>
          <div class="mb-3 sjbzt" style="font-size: calc(11px + 0.4vw);font-weight: 600;">{{ $t("團體認領記錄") }}</div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center pl-3 pr-3 pt-2 pb-2 justify-content-between yuanjiao" style="background: #FFEAB8;width: 49%;">
              <div class="sjbxzt" style="font-size: calc(9px + 0.4vw);">{{ $t("好人積分") }}</div>
              <div class="sjbxzt" style="font-size: calc(9px + 0.4vw);font-weight: 600;">{{ info.sum_good_coin ? info.sum_good_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
            </div>
            <div class="d-flex align-items-center pl-3 pr-3 pt-2 pb-2 justify-content-between yuanjiao" style="background: #FFEAB8;width: 49%;">
              <div class="sjbxzt" style="font-size: calc(9px + 0.4vw);">{{ $t("碳積分") }}</div>
              <div class="sjbxzt" style="font-size: calc(9px + 0.4vw);font-weight: 600;">{{ info.sum_carbon_coin ? info.sum_carbon_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
            </div>
          </div>
          <div class="mt-3">
            <div class="d-flex align-items-center pl-3 pr-3 pt-2 pb-2 justify-content-between yuanjiao mb-3" v-for="(item,index) in info.claim_record" :key="index" style="background: #F6F4F0;width: 100%;">
              <div class="sjbxzt" style="font-size: calc(9px + 0.4vw);">{{ item.organization.name }}</div>
              <div class="d-flex" style="font-size: calc(9px + 0.4vw);">
                <div class="mr-1 sjbxzt" style="color: #666666;">{{ $t("已認領") }}</div>
                <div class="mr-1 sjbxzt" style="font-weight: 600;">{{ item.apply_number }}</div>
                <div class="sjbxzt" style="color: #666666;">{{ $t("本") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import { EventBus } from "@/views/event-bus.js";
import { todonation } from "@/request/jkhd/jkhd";
import { formatTimestamp } from "@/utils/common.js";
import SkeletonScreen from "./SkeletonScreen/glzzSkeletonScreen.vue";
import { goods_detail } from "@/request/aapi.js";
export default {
  components: {
    SkeletonScreen,
  },
  data() {
    return {
      showImage: false, // 是否显示图片
      dataLoaded: false,
      list: [],
      page: 1,
      isLoadMore: false,
      limit: "",
      name: "",
      mediaList: [],
      currentIndex: 0,
      startIndex: 0,
      visibleCount: 7,
      info: {},
      leix: localStorage.getItem("type"),
      // currentMediaType: ""
    };
  },
  created() {},
  mounted() {
    this.getdonation();
  },
  computed: {
    // visibleItems() {
    //   return this.mediaList.slice(
    //     this.startIndex,
    //     this.startIndex + this.visibleCount
    //   );
    // },
  },
  beforeDestroy() {},
  methods: {
    asdfsdgv(e){
      console.log(e)
       this.currentIndex = e;
    },
    dascas() {
      this.$router.push(
        "/claim/item/" + this.$route.params.id + "/supplies-apply"
      );
    },
    move(direction) {
      if (direction === -1) {
        this.currentIndex--;
      } else if (
        direction === 1
      ) {
        this.currentIndex++;
      }
    },
    nextMedia() {
      if (this.currentIndex < this.mediaList.length - 1) {
        this.currentIndex++;
        console.log(this.currentIndex,'this.currentIndex')
      }
    },
    prevMedia() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        console.log(this.currentIndex,'this.currentIndex')
      }
    },
    // 时间转换
    timeFilter(stringTime) {
      return formatTimestamp(stringTime * 1000);
    },
    getdonation() {
      const data = {
        id: this.$route.params.id,
      };
      goods_detail(data).then((res) => {
        if (res.code == 200) {
          this.dataLoaded = true;
          this.info = res.data;
          this.mediaList = res.data.goods_img;
        }
      });
    },
    fanhui(e) {
      this.$router.go(-1);
      // if (this.$route.params.judge == 1) {
      //   this.$router.push("/donation/" + this.$route.params.zjsy);
      //   EventBus.$emit("tthdfhs", "1");
      // } else {
      //   this.$router.push("/donation");
      // }
    },
  },
};
</script>
    
    <style scoped>
@media screen and (max-width: 750px) {
  .asdasd {
    width: calc(60px + 0.4vw) !important;
    height: calc(60px + 0.4vw) !important;
  }
}

@media screen and (max-width: 1201px) {
  .mrt {
    margin-top: 1rem !important;
  }
  .heggs {
    height: 75vh !important;
  }
  .aaaa {
    display: block !important;
  }
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjbdzt {
    font-size: calc(16px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .yinc {
    display: none !important;
  }
  .topg {
    margin-top: 1rem !important;
  }
}
.aaaa {
  display: none;
}

.lieb::-webkit-scrollbar {
  display: none;
}

.thumbnail-container::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
  height: 8px; /* 滚动条高度（横向滚动条时） */
}

.thumbnail-container::-webkit-scrollbar-thumb {
  background: #ffd672; /* 滚动条滑块颜色 */
  border-radius: 4px; /* 滑块圆角 */
}

.thumbnail-container::-webkit-scrollbar-thumb:hover {
  background: #ffd672; /* 滑块悬停时颜色 */
}

.thumbnail-container::-webkit-scrollbar-track {
  background: #f1f1f1; /* 滚动条轨道颜色 */
  border-radius: 4px; /* 轨道圆角 */
}

.dcbd:hover {
  transform: scale(1.06);
}
.gundt::-webkit-scrollbar {
  display: none;
}
.fullscreen-modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.ckqbb:hover {
  transform: scale(1.001);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.thumbnail-container img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border: 2px solid transparent;
  cursor: pointer;
  border-radius: 4px;
  transition: transform 0.2s, border-color 0.2s;
}

.thumbnail-containers img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border: 2px solid transparent;
  cursor: pointer;
  border-radius: 4px;
  transition: transform 0.2s, border-color 0.2s;
}
</style>